import { render } from "./createpurchasereturn.vue?vue&type=template&id=d9d52228&scoped=true"
import script from "./createpurchasereturn.vue?vue&type=script&lang=js"
export * from "./createpurchasereturn.vue?vue&type=script&lang=js"

import "./createpurchasereturn.vue?vue&type=style&index=0&id=d9d52228&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d52228"]])

export default __exports__